import React, { useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import { techStackArray } from "./TechStackArray.js";
import TechStackCard from "./TechStackCard.jsx";
import { motion } from "motion/react";
import { useMediaQuery } from "react-responsive";

const TechStack = (props) => {
  const myRef = useRef(null);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  useEffect(() => {
    if (props.sd === "techstack") {
      console.log(props.sd);
      myRef.current.scrollIntoView();
    }
  }, [props.sd]);

  return (
    <div
      ref={myRef}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          color: "black",
          fontSize: "50px",
          fontWeight: "bold",
          color: "#155BDD",
          marginTop: "50px",
          fontFamily: "Tenorite",
        }}
      >
        TECH STACK
      </h1>
      <br />
      <Row
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "20px",
          marginTop: "20px",
        }}
      >
        {techStackArray.map((tech) => (
          <motion.div
            style={{
              width: "fit-content"
            }}
            initial={{ opacity: 1, scale: 0.5 }}
            whileInView={{ opacity: 1, scale: isTabletOrMobile ? 1.2 : 1 }}
          >
            <TechStackCard
              id={tech.id}
              imageUrlDefault={tech.imageUrlDefault}
              imageUrlOnHover={tech.imageUrlOnHover}
              iconName={tech.iconName}
            />
          </motion.div>
        ))}
      </Row>
    </div>
  );
};

export default TechStack;
